import { FhirService, Issuer } from './../../service/fhir.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../authentication/authentication.service';

@Component({
  selector: 'app-smart-launch',
  templateUrl: './smart-launch.component.html',
  styleUrls: ['./smart-launch.component.scss']
})
export class SmartLaunchComponent implements OnInit
{
  public iss = null;
  public launch = null;
  public fullSite = false;
  public authEndPoint = null;
  public issuerName = {};
  public lastError: string = undefined;
  public errors = Object.freeze({
    invalidParams: 'invalidParams',
    notTrustedIssuer: 'notTrustedIssuer',
    issuerDisabled: 'issuerDisabled',
    unableToGetIssuer: 'unableToGetIssuer'
  });

  constructor(
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private fhirService: FhirService) { }

  public ngOnInit(): void
  {
    this.init();
    this.parseParams();
  }

  private parseParams(): void
  {
    this.route.queryParamMap.forEach(n =>
    {
      n.keys.forEach(key =>
      {
        switch (key)
        {
          case 'iss':
            this.iss = n.get(key);
            break;
          case 'launch':
            this.launch = n.get(key);
            break;
          case 'fullSite':
            this.fullSite = n.get(key) === 'true';
            break;
        }
      });
    });

    // Validate iss and launch
    if (!this.iss || !this.launch)
    {
      this.lastError = this.errors.invalidParams;
    }
    else
    {
      // Validate issuer
      this.fhirService.existsIssuer(this.iss).subscribe({
        next: (issuer: Issuer) =>
        {
          // Set issuerName object used in html for translate params injection
          this.issuerName = { issuer: issuer.name };

          // Set invalid error
          if (!issuer.exists)
          {
            this.lastError = this.errors.notTrustedIssuer;
          }
          else if (!issuer.enabled)
          {
            this.lastError = this.errors.issuerDisabled;
          }
          // If no error detected, get authentication endpoint and navigate
          else if (this.lastError === undefined)
          {
            this.fhirService.getAuthEndpoint(issuer, this.launch, this.fullSite).
              then(data =>
              {
                window.location.assign(data);
              })
              .catch(error =>
              {
                console.error(error);
              });
          }
        },
        error: () =>
        {
          this.lastError = this.errors.unableToGetIssuer;
        }
      });
    }
  }

  private init(): void
  {
    this.iss = null;
    this.launch = null;
    this.fullSite = false;
    this.lastError = undefined;
    this.fhirService.clearStorage();
    this.authService.reset();
  }
}
